import script from "./GestionUsuarios.vue?vue&type=script&setup=true&lang=js"
export * from "./GestionUsuarios.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__